import { useState } from 'react';

import PropTypes from 'prop-types';

import _ from 'lodash';

import Router, { useRouter } from 'next/router';

import BuildingFilterButton from './building-filter-button';

import PriceRangeFilterButton from './price-range-filter-button';

import NumberOfGuestsFilterButton from './number-of-guests-filter-button';

import CategoryFilterButton from './category-filter-button';

import NewRoomFilterButton from './new-room-filter-button';

import useResponsive from '../../../utils/responsive';

const DesktopFilters = (props) => {

    const { buildings, roomTypes } = props;    

    const { isMobile, isTablet, isSmallTablet } = useResponsive();

    const [selectedNumberOfGuests, setSelectedNumberOfGuests] = useState(0);

    const [hideBuildingFilter, setHideBuildingFilter] = useState(false);

    const router = useRouter();

    const query = _.get(router, 'query');

    const onBuildingFilterChange = (values) => {
        const newQuery = { ...query };
        if (values && !_.isEmpty(values)) {
            newQuery.building = values;
        } else {
            delete newQuery.building;
        }
        Router.push(
            {
                pathname: '/bookings',
                query: newQuery,
            },
            undefined,
            { shallow: true },
        );
    };    

    const onPriceRangeChange = (values) => {
        const newQuery = { ...query };
        const min = values[0];
        const max = values[1];
        newQuery.priceMin = min;
        newQuery.priceMax = max;
        Router.push(
            {
                pathname: '/bookings',
                query: newQuery,
            },
            undefined,
            { shallow: true },
        );
    };

    const onGuestCountChange = (value) => {
        const newQuery = { ...query };
        newQuery.guestCount = value;
        setSelectedNumberOfGuests(value);
        Router.push(
            {
                pathname: '/bookings',
                query: newQuery,
            },
            undefined,
            { shallow: true },
        );
    };    

    const onCategoryChange = (values) => {
        const newQuery = { ...query };
        if (values && !_.isEmpty(values)) {
            newQuery.category = values;
        } else {
            delete newQuery.category;
        }
        Router.push(
            {
                pathname: '/bookings',
                query: newQuery,
            },
            undefined,
            { shallow: true },
        );
    };    

    const onNewRoomChange = (value) => {
        const newQuery = { ...query };
        newQuery.new = value;
        Router.push(
            {
                pathname: '/bookings',
                query: newQuery,
            },
            undefined,
            { shallow: true },
        );
    };    

    const renderNewRoomFilterButton = () => {
        return (
            <NewRoomFilterButton 
                id="new-room-filter-button"
                onChange={onNewRoomChange}
            >
                New
            </NewRoomFilterButton>
        );
    };    

    const renderCategoryFilterButton = () => {
        return (
            <CategoryFilterButton
                id="categories-filter-button"
                onChange={onCategoryChange}
                roomTypes={roomTypes}
            >
                Type of Space
            </CategoryFilterButton>
        );
    };    

    const renderNumberOfGuestsFilterButton = () => {
        return (
            <NumberOfGuestsFilterButton
                id="number-of-guests-filter-button"
                onChange={onGuestCountChange}
                numberOfGuests={selectedNumberOfGuests}
            >
                No. of Guests
            </NumberOfGuestsFilterButton>
        );
    };    

    const renderPriceRangeFilterButton = () => {
        return (
            <PriceRangeFilterButton
                id="price-filter-button"
                onChange={onPriceRangeChange}
                roomTypes={roomTypes}
            >
                Price
            </PriceRangeFilterButton>
        );
    };    

    const renderBuildingFilterButton = () => {

        if (hideBuildingFilter) {
            return <p style={{ marginBottom: 93 }} />;
        }

        return (
            <BuildingFilterButton
                id="buildings-filter-button"
                onChange={onBuildingFilterChange}
                buildings={buildings}
                roomTypes={roomTypes}
            >
                Buildings
            </BuildingFilterButton>
        );
    };

    if (isMobile || (isTablet && isSmallTablet)) {
        return null;
    }

    return (

        <div className='desktop-filters-container'>
           
            {renderBuildingFilterButton()}

            {renderPriceRangeFilterButton()}

            {renderNumberOfGuestsFilterButton()}

            {renderCategoryFilterButton()}

            {renderNewRoomFilterButton()}

        </div>

    );
};

export default DesktopFilters;

DesktopFilters.propTypes = {    
    buildings: PropTypes.object,
    roomTypes: PropTypes.array
};

